import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Routing } from '@core/constants/routing.const';
import { AuthService } from '@services/auth/auth.service';
import { CurrentUserService } from '@services/common/currentuser.service';

export const unauthGuard = async () => {
  const authService = inject(AuthService);
  const currentUserService = inject(CurrentUserService);
  const router = inject(Router);

  await currentUserService.getAsync();

  const isUnAuthenticated = authService.isUnAuthenticated();

  if (!isUnAuthenticated) {
    router.navigate([Routing.Secure]);
    currentUserService.IsUserLoggedIn.next(false);
  }

  return isUnAuthenticated;
};
